import React from 'react'
import styled from 'styled-components'
import { BackgroundImage, getPaletteColor } from 'pcln-design-system'

type HeroImageProps = {
  image?: string
  children: React.ReactNode
  backgroundPosition?: string
}

const FixedBackgroundImage = styled(BackgroundImage)`
  background-attachment: fixed;
  background-color: ${getPaletteColor('primary.dark')};
  background-position: ${props => props.backgroundPosition};
`

const DEFAULT_IMAGE =
  'https://s1.pclncdn.com/design-assets/vip/getaways-waterfront-mountain-cottage.jpg?opto&width=1280&optimize=high&auto=webp'

const Hero = ({
  image = DEFAULT_IMAGE,
  children,
  backgroundPosition = 'center',
  ...props
}: HeroImageProps) => (
  <FixedBackgroundImage
    image={image}
    backgroundPosition={backgroundPosition}
    {...props}
  >
    {children}
  </FixedBackgroundImage>
)

export default Hero
